import * as React from 'react';
import {  
    TextField,
    FunctionField ,
    TextInput,
    EditButton
} from 'react-admin';
import { Datagrid, List } from 'src/enterprise/ra-rbac';

const listFilters = [
    <TextInput source="search" label="Search" alwaysOn />
];

export const SheetList = props => {
    return (
        <List {...props} filters={listFilters} queryOptions={{ cacheTime: 0 }}>
            <Datagrid>
                <TextField source="id" />
                <TextField source="name"/>
                <FunctionField label="Total Items" render={record => record.items.length}/>
                <EditButton />
            </Datagrid>
        </List>
    );
};